import BaseUseCase from "../../base_use_case.js.jsx";

class NewInvestmentUseCase extends BaseUseCase {

  execute(projectId) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      params: { projectId: projectId },
      url: `/api/v1/projects/investments/new`,
    });
  }
}

const instance = new NewInvestmentUseCase();
export default instance;